import { usePosts } from '@/hooks/usePosts';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FeaturedCarousel from './components/FeaturedCarousel';
import FeaturedPost from './components/FeaturedPost';
import LatestArticles from './components/LatestArticles';
import CategoryGrid from './components/CategoryGrid';
import NewsletterSection from './components/NewsletterSection';
import Footer from './components/Footer';
import AdSenseAd from '@/components/ads/AdSenseAd';
import Seo, { SITE_URL } from '@/components/base/Seo';

export default function Home() {
  const { getFeaturedPosts, getPublishedPosts } = usePosts();
  const featuredPosts = getFeaturedPosts();
  const publishedPosts = getPublishedPosts();
  const nonFeaturedLatest = publishedPosts.filter(p => !p.featured);

  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Seo
        title="Miau de Casa | Cuidados, saúde e comportamento de gatos"
        description="Dicas e informações sobre cuidados com gatos, saúde felina, alimentação, comportamento, raças e bem-estar para seu gato viver melhor."
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'Miau de Casa',
          alternateName: 'Miaudecasa',
          url: SITE_URL,
          inLanguage: 'pt-BR',
        }}
      />
      <Navbar />

      {/* Hero */}
      <HeroSection />

      {/* Featured Carousel (if there are featured posts) */}
      {featuredPosts.length > 0 ? (
        <FeaturedCarousel posts={featuredPosts} />
      ) : publishedPosts.length > 0 ? (
        <FeaturedPost post={publishedPosts[0]} />
      ) : null}

      {/* Latest Articles */}
      <LatestArticles posts={nonFeaturedLatest.length > 0 ? nonFeaturedLatest : publishedPosts} />

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 md:py-6">
        <AdSenseAd placement="home" />
      </div>

      {/* Category Grid */}
      <CategoryGrid />

      {/* Newsletter */}
      <NewsletterSection />

      {/* Footer */}
      <Footer popularPosts={publishedPosts} />
    </div>
  );
}
